/**
 * HeaderPill Component
 * MED-263: Styled pill for cohort header showing status/health with a colored dot
 * Specs: 20px radius, rgba(255,255,255,0.70) bg, subtle shadow, 8px colored dot
 */

import { Group, Text, Box } from '@mantine/core';

interface HeaderPillProps {
  dotColor: string;
  label: string;
}

export function HeaderPill({ dotColor, label }: HeaderPillProps) {
  return (
    <Box
      style={{
        borderRadius: 20,
        background: 'rgba(255, 255, 255, 0.70)',
        boxShadow: '0 4px 6px -4px rgba(0, 0, 0, 0.06)',
        padding: '6px 12px',
      }}
    >
      <Group gap={8} wrap="nowrap">
        <Box
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: dotColor,
            flexShrink: 0,
          }}
        />
        <Text size="sm" fw={600} style={{ color: '#28463A', whiteSpace: 'nowrap' }}>
          {label}
        </Text>
      </Group>
    </Box>
  );
}
